/**
 * 获取最大最小日期时从validProps中获取；其他属性从props中获取
 */
import React from 'react';
import { View, StyleSheet } from 'react-native';
import { QFlatList } from '@qnpm/q-flatlist';
import { commonUtil } from '@qnpm/q-design-utils';
import BaseCalendar from './BaseCalendar';
import WeekHeader from './WeekHeader';
import FakeDayText from './FakeDayText';
import MonthHeader from './MonthHeader';
import MonthContent from './MonthContent';
import { StickyHeader } from './StickyHeader';
import { computeFlatRenderData, computeFlatStickyIndices } from '../../utils/handle';
export default class QSectionCalendar extends BaseCalendar {
    constructor(props) {
        super(props, 'flat');
        this.initialScrollIndex = 0;
        this.renderData = [];
        this.onListLayout = () => {
            this.showLimitMessage();
        };
        /**
         * 渲染列表内容
         * @param item
         * @param rowID
         */
        this.renderItem = (item, rowID) => {
            const isHeader = rowID % 2 === 0;
            const monthID = (rowID - 1) / 2;
            // 渲染头部
            if (isHeader) {
                return this.renderMonthHeader(item, monthID);
            }
            // 渲染月份内容
            return this.renderMonthContent(item, monthID);
        };
        /**
         * 渲染月份内容
         * @param item
         * @param rowID
         */
        this.renderMonthContent = (item, rowID) => {
            const { selectedDate, showToolTipMonth, selectedSameDay, startTime, endTime, allowDates, denyDates } = this.state;
            const { showUnderMonth, dayScale, mode, dataSource, accessibilityPreName, denyWeeks, refreshWidth } = this.props;
            const { monthKey, year, month, weekList } = item;
            const canShowToolTip = showToolTipMonth === monthKey;
            return (<MonthContent key={monthKey + rowID} rowID={rowID} year={year} month={month} dataSource={weekList} startTime={startTime} endTime={endTime} allowDates={allowDates} denyDates={denyDates} denyWeeks={denyWeeks} mode={mode} dataConfig={dataSource} canShowToolTip={canShowToolTip} showUnderMonth={showUnderMonth} selectedSameDay={selectedSameDay} selectedDate={selectedDate} onSelect={this.updateState} dayScale={dayScale} computedStyle={this.computedStyle} needScale={this.needScale} accessibilityPreName={accessibilityPreName} refreshWidth={refreshWidth}/>);
        };
        /**
         * 计算每一个子模块的高度，用于优化性能
         * @param _
         * @param index
         */
        this.computeItemLayout = (_, index) => {
            const { monthHeader } = this.calendarLayout;
            const isHeader = index % 2 === 0;
            // 默认返回0
            if (index === -1) {
                return { length: 0, offset: 0, index };
            }
            // 头部单独处理
            if (isHeader) {
                const headerOffsetIndex = index / 2;
                const headerOffset = this.monthHeight
                    .slice(0, headerOffsetIndex)
                    .reduce((prev, next) => prev + next, 0);
                return { length: monthHeader.height, offset: headerOffset, index };
            }
            // 内容偏移计算
            const contentOffsetIndex = (index - 1) / 2;
            const contentLen = this.monthHeight[contentOffsetIndex];
            const contentOffset = this.monthHeight
                .slice(0, contentOffsetIndex)
                .reduce((prev, next) => prev + next, 0) + monthHeader.height;
            return { length: contentLen, offset: contentOffset, index };
        };
        const { stickyHeader } = props;
        this.stickyHeaderIndices = stickyHeader
            ? computeFlatStickyIndices(this.state.calendarData.length)
            : [];
        // 默认滚动到月份顶部
        this.initialScrollIndex = this.selectedMonthIndex * 2;
        this.renderData = computeFlatRenderData(this.state.calendarData);
    }
    render() {
        const { initialNumToRender, selectedPayload, refreshWidth } = this.props;
        return (<>
                
                {commonUtil.isValidArray(selectedPayload) ? (<FakeDayText data={selectedPayload} computedStyle={this.computedStyle}/>) : null}
                <View style={styles.wrapper}>
                    <WeekHeader data={this.weekHeaderData} computedStyle={this.computedStyle} refreshWidth={refreshWidth}/>
                    
                    <QFlatList data={this.renderData} ref={(ref) => {
            // @ts-ignore
            this.scrollRef = ref;
            this.getScrollRef(ref);
        }} onLayout={this.onListLayout} initialScrollIndex={this.initialScrollIndex} initialNumToRender={initialNumToRender} stickyHeaderIndices={this.stickyHeaderIndices} renderItem={({ item, index }) => this.renderItem(item, index)} keyExtractor={(item, index) => item.title +
            '_' +
            (item.isHeader
                ? `header_${this.needAdjustZIndex(index)}`
                : 'content')} getItemLayout={(data, index) => this.computeItemLayout(data, index)} 
        // @ts-ignore
        getScrollResponder={this.getScrollResponder} StickyHeaderComponent={StickyHeader} onScroll={this.onScroll}/>
                </View>
            </>);
    }
    /**
     * 判断是否需要调整头部
     * @private
     */
    needAdjustZIndex(index) {
        const { selectedPayload, stickyHeader = true } = this.props;
        // 如果没有提示信息或不需要吸顶时，则不需要调整头部层级
        if (!commonUtil.isValidArray(selectedPayload) || !stickyHeader) {
            return false;
        }
        // 渲染的头部所属月份下标
        const sectionIndex = index / 2;
        const { position } = this.computedSelectedPosition(false);
        let rowIndex = -1;
        let monthIndex = 0;
        // 如果找到了选中位置，设置选中的月份和行数的下标
        if (position) {
            // @ts-ignore
            monthIndex = Math.max(...Object.keys(position));
            rowIndex = position[monthIndex] || 0;
        }
        // 只有选中日期在当前月份且在第0行的时候才需要调整
        return rowIndex === 0 && sectionIndex === monthIndex;
    }
    /**
     * 渲染头部
     * @param data
     * @param rowID
     * @private
     */
    renderMonthHeader(data, rowID) {
        const { monthHeaderConfig = {}, accessibilityPreName, mode } = this.props;
        const { monthKey, title } = data;
        return (<MonthHeader key={'header_' + monthKey + rowID} title={title} config={monthHeaderConfig[monthKey]} computedStyle={this.computedStyle} accessibilityPreName={accessibilityPreName} mode={mode}/>);
    }
    /**
     * 父组件中的CalendarData发生变化时，会调用此函数来更新列表的渲染数据
     * @param calendarData
     * @private
     */
    onCalendarDataChanged(calendarData) {
        this.renderData = computeFlatRenderData(calendarData);
    }
}
const styles = StyleSheet.create({
    wrapper: {
        flex: 1,
        backgroundColor: '#FFFFFF'
    }
});
